import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange'
import { ContextBuilder } from "../../../../context/builder/reducers";
import Input from '../Input';
import UploadButton from '../UploadButton';

const ImgTitle = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                title: '', img: null
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });

    return (
        <div className="img-title">
            <h2>Image title block</h2>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <label>Заголовок</label>
                        <Input name="title" onChange={onChange} value={props.content.title}/>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group d-flex">
                        <div>
                            <label>Изображение</label>
                            <div className="images">
                                <div className="img-container">
                                    <div className="img-wrap">
                                        <img src={props.content.img}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pt-3">
                            <UploadButton name="img" onChange={onChange}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ImgTitle;
